"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.majorList = exports.majorDel = exports.majorChange = exports.getMatchMajorListAll = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
/**
 * 描述 获取专业大类列表
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var majorList = exports.majorList = function majorList(data) {
  return _api.default.request({
    url: '/matchMajor/getMatchMajorListPage',
    method: 'post',
    data: data
  });
}; /**
   * 描述 获取专业大类列表全部
   * @author kkdy
   * @date 2021-11-23
   * @param {any} data
   * @returns {any}
   */
var getMatchMajorListAll = exports.getMatchMajorListAll = function getMatchMajorListAll(data) {
  return _api.default.request({
    url: '/matchMajor/getMatchMajorListAll',
    method: 'post',
    data: data
  });
};
/**
 * 描述 删除专业大类
 * @author kkdy
 * @date 2021-11-26
 * @param {any} data
 * @returns {any}
 */
var majorDel = exports.majorDel = function majorDel(data) {
  return _api.default.request({
    url: '/matchMajor/deleteMajor',
    method: 'post',
    data: data
  });
};
/**
 * 描述 新增/修改专业大类
 * @author kkdy
 * @date 2021-11-26
 * @param {any} data
 * @returns {any}
 */
var majorChange = exports.majorChange = function majorChange(data) {
  return _api.default.request({
    url: '/matchMajor/insertOrUpdateMajor',
    method: 'post',
    data: data
  });
};